import { Component, OnInit, input, output, signal } from '@angular/core';

import { QrCodeLinkPayload, QrCodeLinkResponse } from '../../interfaces/qrcode.interface';
import { environment } from 'src/environments/environment';
import { NiboService } from '../../services/nibo.service';

@Component({
  standalone: false,
  selector: 'app-whitelabel-qrcode',
  templateUrl: './whitelabel-qrcode.component.html',
  styleUrls: ['./whitelabel-qrcode.component.css']
})
export class WhitelabelQrcodeComponent implements OnInit {

  readonly accountantId = input<string>();

  readonly fetchedLinkEvent = output<QrCodeLinkResponse>();

  public readonly status = signal<'loading' | 'completed' | undefined>(undefined);

  constructor(private niboService: NiboService) { }

  ngOnInit(): void {}

  public fetchQrCodeLink() {
    const accountantId = this.accountantId();
    if (!accountantId) return;

    this.status.set('loading');

    const qrCodePayload: QrCodeLinkPayload = {
      url: `${environment.sources.accountantApi}/accountants/${accountantId}/integrations/redirecttocustomapp`
    };

    this.niboService.getQrCodeLink(accountantId, qrCodePayload).subscribe({
      next: (qrCodeResponse) => {
        this.fetchedLinkEvent.emit(qrCodeResponse);        
      },
      complete: () => {
        this.status.set('completed');
      }
    });
  }
}
